import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './MobileNav.css';

const navItems = [
  { label: 'INICIO', action: 'scroll-top' },
  { label: 'EQUIPO', path: '/equipo' },
  { label: 'BODEGAS', path: '/bodegas' },
  { label: 'HISTORIA', path: '/historia' },
  { label: 'KIT DE MARCA', path: '/kit-de-marca' },
  { label: 'TIENDA', path: '/#tienda' },
];

const MobileNav = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { toggleCart, getTotalItems } = useCart();

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const handleClick = (item) => {
    onClose();
    if (item.action === 'scroll-top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      navigate('/');
    } else if (item.path) {
      navigate(item.path);
    }
  };

  const handleCart = () => {
    onClose();
    toggleCart();
  };

  const content = (
    <div
      className={`mobile-nav-overlay${open ? ' mobile-nav-overlay--open' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="Menú de navegación"
    >
      <div className="mobile-nav-backdrop" onClick={onClose} aria-hidden />
      <div className="mobile-nav-panel">
        <button
          type="button"
          className="mobile-nav-close"
          onClick={onClose}
          aria-label="Cerrar menú"
        >
          ×
        </button>
        <div className="mobile-nav-inner">
          {navItems.map((item) => (
            <button
              key={item.label}
              type="button"
              className="mobile-nav-link"
              onClick={() => handleClick(item)}
            >
              {item.label}
            </button>
          ))}
          <button type="button" className="mobile-nav-link mobile-nav-cart" onClick={handleCart}>
            <span className="cart-icon">🛒</span> CARRITO
            {getTotalItems() > 0 && (
              <span className="mobile-nav-cart-badge">{getTotalItems()}</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default MobileNav;
